import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const ExtraBoxPortal = (props) => {
    const { children } = props;
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, [])

    return mounted ? createPortal(children, document.querySelector("#extra-box")) : null;
}

export default ExtraBoxPortal